/* ═══════════════════════════════════════════
   NW AGENCY – THEME JS
   ═══════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function () {

  /* ─── Search overlay ─── */
  var searchOverlay = document.querySelector('[data-search-overlay]');
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchClose = document.querySelector('[data-search-close]');
  var searchInput = document.querySelector('[data-search-input]');

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('search-overlay--open');
    document.body.style.overflow = 'hidden';
    if (searchInput) {
      setTimeout(function () { searchInput.focus(); }, 100);
    }
  }
  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('search-overlay--open');
    document.body.style.overflow = '';
  }

  if (searchToggle) {
    searchToggle.addEventListener('click', function (e) {
      e.preventDefault();
      openSearch();
    });
  }
  if (searchClose) {
    searchClose.addEventListener('click', function () { closeSearch(); });
  }
  if (searchOverlay) {
    searchOverlay.addEventListener('click', function (e) {
      if (e.target === searchOverlay) closeSearch();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSearch();
  });

  /* ─── Mobile menu drawer ─── */
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var menuClose = document.querySelector('[data-menu-close]');
  var menuBackdrop = document.querySelector('[data-menu-backdrop]');

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('mobile-menu--open');
    if (menuBackdrop) menuBackdrop.classList.add('mobile-menu__backdrop--open');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('mobile-menu--open');
    if (menuBackdrop) menuBackdrop.classList.remove('mobile-menu__backdrop--open');
    document.body.style.overflow = '';
  }

  if (menuToggle) {
    menuToggle.addEventListener('click', function () { openMobileMenu(); });
  }
  if (menuClose) {
    menuClose.addEventListener('click', function () { closeMobileMenu(); });
  }
  if (menuBackdrop) {
    menuBackdrop.addEventListener('click', function () { closeMobileMenu(); });
  }

  /* ─── Mobile submenu expand ─── */
  document.querySelectorAll('[data-mobile-expand]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var parent = this.closest('.mobile-menu__item');
      var sub = parent ? parent.querySelector('[data-mobile-sub]') : null;
      if (!sub) return;
      var isOpen = sub.classList.contains('mobile-menu__sub--open');
      sub.classList.toggle('mobile-menu__sub--open');
      this.classList.toggle('mobile-menu__expand--open');
    });
  });

  /* ─── Product image gallery ─── */
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var url = this.dataset.imageUrl;
      var mainImg = document.getElementById('product-main-image');
      if (mainImg && url) {
        mainImg.src = url;
        document.querySelectorAll('[data-thumb]').forEach(function (t) {
          t.classList.remove('product-gallery__thumb--active');
        });
        this.classList.add('product-gallery__thumb--active');
      }
    });
  });

  /* ─── Product variant selection & price update ─── */
  var productJsonEl = document.querySelector('[data-product-json]');
  var productData = null;
  if (productJsonEl) {
    try { productData = JSON.parse(productJsonEl.textContent); } catch (e) {}
  }

  function formatMoney(cents) {
    if (!productData) return '';
    var format = productData.money_format || '{{amount}} €';
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    var amountNoDecimals = Math.floor(cents / 100).toString();
    return format
      .replace('{{amount_with_comma_separator}}', amount)
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', amountNoDecimals)
      .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimals);
  }

  function getSelectedOptions() {
    var options = [];
    document.querySelectorAll('.product-options__group').forEach(function (group) {
      var selected = group.querySelector('.product-option-btn--selected');
      options.push(selected ? selected.dataset.optionValue : '');
    });
    return options;
  }

  function findVariant(selectedOptions) {
    if (!productData) return null;
    for (var i = 0; i < productData.variants.length; i++) {
      var v = productData.variants[i];
      var match = true;
      for (var j = 0; j < selectedOptions.length; j++) {
        if (v.options[j] !== selectedOptions[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function updateVariant() {
    var selectedOptions = getSelectedOptions();
    var variant = findVariant(selectedOptions);
    var priceBox = document.querySelector('.product-price');
    var select = document.querySelector('[data-product-select]');
    var addBtn = document.querySelector('[data-add-to-cart]');

    if (variant && priceBox) {
      // Update price display
      var priceHtml = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceHtml += '<span class="product-price__compare">' + formatMoney(variant.compare_at_price) + '</span> ';
      }
      priceHtml += formatMoney(variant.price);
      priceHtml += ' <span class="product-price__vat">inkl. MwSt.</span>';
      priceBox.innerHTML = priceHtml;

      // Update hidden select
      if (select) { select.value = variant.id; }

      // Update button state
      if (addBtn) {
        if (variant.available) {
          addBtn.disabled = false;
          addBtn.innerHTML = '🛒 In den Warenkorb';
        } else {
          addBtn.disabled = true;
          addBtn.innerHTML = 'Ausverkauft';
        }
      }

      // Update URL without reload
      if (window.history && window.history.replaceState) {
        var url = window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({}, '', url);
      }
    }
  }

  document.querySelectorAll('.product-option-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = this.closest('.product-options__group');
      group.querySelectorAll('.product-option-btn').forEach(function (b) {
        b.classList.remove('product-option-btn--selected');
      });
      this.classList.add('product-option-btn--selected');
      updateVariant();
    });
  });

  /* Run once on page load to match price to pre-selected variant */
  if (productData) { updateVariant(); }

  /* ─── Product tabs ─── */
  document.querySelectorAll('[data-tab]').forEach(function (tabBtn) {
    tabBtn.addEventListener('click', function () {
      var tabId = this.dataset.tab;
      document.querySelectorAll('[data-tab]').forEach(function (b) {
        b.classList.remove('product-tabs__btn--active');
      });
      this.classList.add('product-tabs__btn--active');
      document.querySelectorAll('[data-tab-content]').forEach(function (content) {
        content.style.display = content.dataset.tabContent === tabId ? 'block' : 'none';
      });
    });
  });

  /* ─── Header scroll effect ─── */
  var header = document.querySelector('[data-header]');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 50) {
        header.style.borderBottomColor = 'rgba(0,255,255,0.1)';
      } else {
        header.style.borderBottomColor = 'rgba(0,255,255,0.06)';
      }
    }, { passive: true });
  }

  /* ─── Drag-to-scroll for testimonials carousel ─── */
  document.querySelectorAll('.testimonials-grid').forEach(function (slider) {
    var isDown = false, startX, scrollLeft;
    slider.addEventListener('mousedown', function (e) {
      isDown = true; slider.style.cursor = 'grabbing';
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener('mouseleave', function () { isDown = false; slider.style.cursor = 'grab'; });
    slider.addEventListener('mouseup', function () { isDown = false; slider.style.cursor = 'grab'; });
    slider.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - slider.offsetLeft;
      slider.scrollLeft = scrollLeft - (x - startX) * 1.5;
    });
  });

  /* ─── Smooth scroll for anchor links ─── */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

});